// extracted by mini-css-extract-plugin
export var labelWrapper = "_ek-0";